// @flow
const findGroup = (group: Object, id: string, event: Object) =>
   (group.id === id) && ((Math.abs(group.lastEventTime - event.event.timestamp) / 36e5) < 1.5);

export default (list: Array<Object> = []) => {
  const groups = [];

  list.forEach((item) => {
    const id = item.ownerId + item.event.meta.medication + item.event.meta.sessionId;

    if (groups.find(i => findGroup(i, id, item)) === undefined) {
      groups.push({
        events: [],
        id,
        lastEventTime: item.event.timestamp,
        time: item.event.timestamp,
        ownerId: item.ownerId,
        taken: false,
        medication: {
          amount: item.event.meta.amount,
          name: item.event.meta.medication,
        },
      });
    }

    const group = groups.find(i => findGroup(i, id, item));

    if (item.event.event.split('.')[1] === 'taken' && group) {
      group.taken = true;
    }

    if (group) {
      group.lastEventTime = item.event.timestamp;
      group.events.push(item);
    }
  });

  return groups;
};



// WEBPACK FOOTER //
// ./src/scenes/Medication/components/MedicationList/util/GroupEvents.js